import { DefaultPrimaryButton } from '@frontend/components/common';
import { DefaultModal, ModalType } from '@frontend/components/kiosk';
import { Keyboard } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { LuX } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { useManualIdentification } from './manual-identification.controller';

const ID = 'manual-identification';

export const ManualIdentification = () => {
    const viewProps = useManualIdentification();

    if (!viewProps.visible) {
        return null;
    }

    return (
        <>
            <button
                id={ID}
                type='button'
                aria-label={viewProps.openLabel}
                data-testid='manual-identification-button'
                onClick={viewProps.open}
                className='bg-background-surface text-brand-muted absolute bottom-6 left-6 z-10 flex size-10 cursor-pointer items-center justify-center rounded-xl'>
                <Keyboard className='size-5' />
            </button>
            <DefaultModal
                id={`${ID}-modal`}
                handleClose={viewProps.close}
                show={viewProps.show}
                type={ModalType.PROMPT}
                className='bg-background-surface m-12 overflow-hidden rounded-2xl p-6'>
                <div className='flex flex-col items-stretch justify-start gap-6'>
                    <div className='flex h-6 items-start justify-between self-stretch'>
                        <div className='text-foreground-default text-xl font-semibold'>
                            <FormattedMessage
                                id='kiosk.home.manual-identification.title'
                                defaultMessage='Enter your badge'
                                description='Title of the manual identification modal on the kiosk home screen'
                            />
                        </div>
                        <button
                            type='button'
                            className='relative flex size-6 cursor-pointer items-center justify-center overflow-hidden'
                            onClick={viewProps.close}
                            data-testid='manual-identification-close-button'>
                            <LuX className='text-foreground-default size-6' />
                        </button>
                    </div>
                    <input
                        ref={viewProps.inputRef}
                        id={`${ID}-input`}
                        data-testid='manual-identification-input'
                        autoFocus
                        autoComplete='off'
                        spellCheck={false}
                        inputMode='text'
                        disabled={viewProps.isSubmitting}
                        value={viewProps.identification}
                        placeholder={viewProps.placeholder}
                        onChange={(event) => viewProps.setIdentification(event.target.value)}
                        onFocus={(event) => event.target.select()}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                viewProps.onSubmit();
                            }
                        }}
                        className='bg-background-surface outline-border-default h-11 w-full rounded-xl px-4 text-base font-medium outline-1 outline-offset-[-1px]'
                    />
                    <div className='flex items-start justify-end self-stretch'>
                        <DefaultPrimaryButton
                            text={CommonMessage.BUTTONS.SUBMIT}
                            onClick={viewProps.onSubmit}
                            disabled={!viewProps.canSubmit}
                            isLoading={viewProps.isSubmitting}
                            dataTestId='manual-identification-submit-button'
                        />
                    </div>
                </div>
            </DefaultModal>
        </>
    );
};

export default ManualIdentification;
